import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { BeforeAfter } from './components/BeforeAfter';
import { WhyUs } from './components/WhyUs';
import { Process } from './components/Process';
import { ServiceArea } from './components/ServiceArea';
import { Reviews } from './components/Reviews';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-dark flex flex-col" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <Services data-id="element-4" />
        <BeforeAfter data-id="element-5" />
        <WhyUs data-id="element-6" />
        <Process data-id="element-7" />
        <ServiceArea data-id="element-8" />
        <Reviews data-id="element-9" />
        <FinalCTA data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}